import { Vertical } from 'gls';
import styled from 'styled-components';
import { colours } from 'styling/colours';
import BatterySpan from 'views/assets/AssetFlyout/BatterySpan';
import { useRootStore } from 'contexts/RootStore.context';
import { Asset } from 'types/asset';
import DefaultCell from 'components/DataTable/cells/DefaultCell';
import LastSeenCell from './LastSeenCell';
import LocationCellAsset from './LocationCellAsset';
import AssetStatusCell from './AssetStatusCell';

type MobileAssetColumnProps = {
  asset: Asset;
  onClick: (arg: any) => void;
};
export const MobileAssetRow = ({ asset, onClick }: MobileAssetColumnProps) => {
  const { availableFeatures } = useRootStore();

  return (

    <AssetContainerStyle onClick={() => onClick(asset)}>
      <Vertical spacing={10}>
        <span className="asset-name">{asset.asset_name}</span>
        {asset.asset_type.is_enabled && (
          <span>
            <DefaultCell value={asset.asset_type.name} />
          </span>
        )}
        <table>
          <thead>
            <tr>
              <td className="title">LAST SEEN:</td>
              <td>
                {asset.last_location_update_timestamp ? (
                  <LastSeenCell timestamp={asset.last_location_update_timestamp} />
                ) : (
                  '––'
                )}
              </td>
            </tr>
          </thead>
          <thead>
            <tr>
              <td className="title">LOCATION:</td>
              <td>
                <LocationCellAsset value={asset} />
              </td>
            </tr>
          </thead>

          <thead>
            <tr>
              <td className="title">OWNER:</td>
              <td>
                <DefaultCell value={asset.owner.name} />
              </td>
            </tr>
          </thead>

          {availableFeatures.asset_status && (
            <thead>
              <tr>
                <td className="title">STATUS:</td>
                <AssetStatusCell value={asset.status_assignment?.asset_status?.description} />
              </tr>
            </thead>
          )}
          <thead>
            <tr>
              <td className="title">BATTERY:</td>
              <td>
                <BatterySpan asset={asset} />
              </td>
            </tr>
          </thead>
        </table>
      </Vertical>
    </AssetContainerStyle>
  );
};

const AssetContainerStyle = styled.div`
  width: 100%;

  table td {
    vertical-align: top;
    padding-bottom: 4px;
  }
  .title {
    width: 100px;
    color: ${colours.primary};
  }
  .asset-name {
    font-weight: bold;
  }
`;
